module.exports = {"511903001":"登科街道","511903002":"文治街道","511903003":"司城街道","511903100":"明阳镇","511903101":"玉山镇","511903102":"渔溪镇","511903103":"三河场镇","511903104":"青木镇","511903105":"花丛镇","511903106":"柳林镇","511903107":"下八庙镇","511903108":"茶坝镇","511903109":"观音井镇","511903110":"三汇镇","511903111":"上八庙镇","511903112":"关公镇","511903113":"兴隆场镇","511903114":"双胜镇","511903115":"群乐镇","511903116":"义兴镇","511903200":"三星乡","511903202":"舞凤乡","511903204":"石城乡","511903205":"九镇乡","511903206":"尹家乡","511903209":"万安乡","511903210":"玉井乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511903.json
// module id = 2389
// module chunks = 0